export const calculatePercentageValue = (value: number, min: number, max: number): number => {
  // Ensure the value stays within the min-max range
  const clampedValue = Math.max(min, Math.min(value, max));

  // Calculate the percentage representation of the progress
  return ((clampedValue - min) / (max - min)) * 100;
}